import { Injectable } from '@angular/core';
import { AppSettings } from '../app.settings';
import { BehaviorSubject, Subject } from 'rxjs';
@Injectable()
export class StorageService {
  private dataSubject = new Subject<any>();
  public logout: Subject<any> = new Subject<any>();
  public logoutPopup: Subject<any> = new Subject<any>();
  cookiesItems = [];

  constructor() { }

  getItem<T>(key: string): T {
    let result = null;
    result = sessionStorage.getItem(key);
    if (result) {
      result = JSON.parse(result);
    }
    return result;
  }

  setItem<T>(key: string, value: T) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  removeItem<T>(key: string) {
    sessionStorage.removeItem(key);
  }

  setLocalStorage<T>(key: string, value: T) {
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItemLocalStorage<T>(key: string): T {
    let result = null;
    result = localStorage.getItem(key);
    if (result != null) {
      result = JSON.parse(result);
    }
    return result;
  }

  removeAll<T>() {
    sessionStorage.clear();
    localStorage.clear();
  }

  removeAllCookies() {
    const that = this;
    this.cookiesItems.forEach(key => {
      that.setItemInCookies(key, '');
    });
  }

  setItemInCookies(key: string, value: string) {
    this.cookiesItems.push(key);
    const d = new Date();
    d.setTime(d.getTime() + AppSettings.COOKIE_EXPIRY);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = key + '=' + value + ';' + expires + ';path=/';
  }

  getItemFromCookies(key: string) {
    const name = key + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }

  

  sendData(data: any) {
    this.dataSubject.next(data);
  }

  getData() {
    return this.dataSubject.asObservable();
  }

}
